import { CountdownDetails } from './types';

const floorWithZeroMin = (n: number) => Math.max(0, Math.floor(n));

export const getCountdownTime = (futureDate: Date): CountdownDetails => {
  const currentTime = new Date();
  const timeDifference = (futureDate.getTime() - currentTime.getTime()) / 1000 / 60 / 60 / 24;
  const days = floorWithZeroMin(timeDifference);
  const hours = floorWithZeroMin((timeDifference % 1) * 24);
  const minutes = floorWithZeroMin((((timeDifference % 1) * 24) % 1) * 60);
  const seconds = floorWithZeroMin((((((timeDifference % 1) * 24) % 1) * 60) % 1) * 60);
  return { days, hours, minutes, seconds, timeDifference };
};
